import { useState } from "react"
import { Card, CardHeader, Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap"
import { TicketReportList } from "./ticket-report-list"
import { VehicleReportList } from "./vehicle-report-list"

export function EntryReportList() {
  const [activeTab, setActiveTab] = useState("1")

  const toggle = (tab: string) => {
    if (activeTab !== tab) setActiveTab(tab)
  }

  return (
    <Card className="shadow mb-4">
      <CardHeader className="p-0">
        <Nav tabs className="border-bottom">
          <NavItem>
            <NavLink
              className={`nav-link ${activeTab === "1" ? "active" : ""}`}
              onClick={() => toggle("1")}
              style={{ cursor: "pointer" }}
            >
              Ticket Report
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={`nav-link ${activeTab === "2" ? "active" : ""}`}
              onClick={() => toggle("2")}
              style={{ cursor: "pointer" }}
            >
              Vehicle Report
            </NavLink>
          </NavItem>
        </Nav>
      </CardHeader>
      <TabContent activeTab={activeTab}>
        <TabPane tabId="1">
          <TicketReportList />
        </TabPane>
        <TabPane tabId="2">
          <VehicleReportList />
        </TabPane>
      </TabContent>
    </Card>


  )
}
